export const UPDATE_TERMINAL_GENERAL_DATA = 'terminals/UPDATE_TERMINAL_GENERAL_DATA'
export const UPDATE_TERMINAL_SERVICE_DATA = 'terminals/UPDATE_TERMINAL_SERVICE_DATA'
export const UPDATE_TERMINAL_MAINTENANCE_DATA = 'terminals/UPDATE_TERMINAL_MAINTENANCE_DATA'
export const UPDATE_TERMINAL_SCHEDULES_DATA = 'terminals/UPDATE_TERMINAL_SCHEDULES_DATA'
export const UPDATE_TERMINAL_AMOUNT = 'terminals/UPDATE_TERMINAL_AMOUNT'
export const UPDATE_ORGANIZATION_TERMINALS = 'terminals/UPDATE_ORGANIZATION_TERMINALS'
export const UPDATE_ADMIN_ORGANIZATION_TERMINALS = 'terminals/UPDATE_ADMIN_ORGANIZATION_TERMINALS'
export const IS_LOADING = 'terminals/IS_LOADING'
export const UPDATE_TERMINAL_MESSAGES_DATA = 'terminals/UPDATE_TERMINAL_MESSAGES_DATA'
